// extracted by mini-css-extract-plugin
export default {"warning":"RequestHaulerBlock_warning__0bQcA","warningText":"RequestHaulerBlock_warningText__kkpar","warningBody":"RequestHaulerBlock_warningBody__VuPjf"};